import React, { useCallback, useState } from 'react'

import { VerticalCarousel } from 'shared/components'

import { catalogItems, RenderCatalogItem } from './CatalogItems'
import classes from './CatalogSlide.module.scss'

export const CatalogSlider = (): JSX.Element => {
  const [muted, setMuted] = useState(true)
  const [activeSlide, setActiveSlide] = useState(0)
  const items = catalogItems

  const toggleMute = useCallback(() => {
    setMuted(isMuted => !isMuted)
  }, [])

  function selectNextSlide(currIdx: number, arrLength: number) {
    if (currIdx !== undefined && arrLength !== undefined) {
      const nextSlideIdx = currIdx + 1 <= arrLength - 1 ? currIdx + 1 : 0
      setActiveSlide(nextSlideIdx)
    }
  }

  const renderItems = useCallback(
    () =>
      items.map((item, itemIndex) => (
        <RenderCatalogItem
          key={itemIndex}
          {...catalogItems[itemIndex]}
          muted={muted}
          toggleMute={toggleMute}
          isActive={itemIndex === activeSlide}
          selectNextSlide={() => selectNextSlide(itemIndex, items.length)}
        />
      )),
    [activeSlide, items, muted, toggleMute]
  )

  return (
    <div className={classes.container}>
      <VerticalCarousel
        activeSlideIdx={activeSlide}
        sliderItems={items}
        onChange={v => setActiveSlide(v)}
      />
      {renderItems()}
    </div>
  )
}
